<div class="container">
    <!-- Search form component -->
    <app-rsa-search-form
        [loading]="loading"
        (search)="onSearchSubmitted($event)"
        (reset)="onSearchReset()">
    </app-rsa-search-form>
    
    <!-- Certificate pagination component -->
    <app-certificate-pagination
        *ngIf="totalCertificate > 1"
        [certificates]="certificates"
        [currentCertificateIndex]="currentCertificateIndex"
        [totalCertificate]="totalCertificate"
        (previous)="previousAction()"
        (next)="nextAction()"
        (pageSelected)="pageSelected($event)">
    </app-certificate-pagination>
</div>

<!-- Certificate details component -->
<div class="container" *ngIf="totalCertificate >= 1">
    <app-certificate-details
        [certificate]="selectedCertificate"
        [isCertificateExpired]="isCertificateExpired"
        (addNewRsaService)="enterRSAClick()"
        (copyContactNumber)="copyToClipboard($event)">
    </app-certificate-details>
</div>

<!-- RSA Service form component -->
<div class="container" style="margin-top: 20px;" *ngIf="showRsaForm">
    <app-rsa-service-form
        [selectedCertificate]="selectedCertificate"
        [loading]="loading"
        [submitted]="submitted"
        [rsaProvidedForm]="rsaProvidedForm"
        [stateList]="stateList"
        [cityList]="cityList"
        [providerList]="providerList"
        [selectedProviderContactNumber]="selectedProviderContactNumber"
        [newHistoryCommentControl]="newHistoryCommentControl"
        (formSubmit)="onRsaSubmit()"
        (providerChange)="onProviderChange($event)"
        (copyToClipboard)="copyToClipboard($event)"
        (autoFillLocation)="autoFillLocation()"
        (copyCustomerInfo)="copyCustomerInfo()"
        (formCancel)="cancelRsaForm()">
    </app-rsa-service-form>
</div>
<!-- RSA Service history component -->
<div class="container" *ngIf="totalCertificate >= 1 && rsaProvidedList.length > 0" style="margin-top: 20px;">
    <app-rsa-service-history
        [rsaProvidedList]="rsaProvidedList"
        [isCertificateExpired]="isCertificateExpired"
        [loading]="loading"
        (markAsCompleted)="addRequestHistory($event)"
        (copyContactNumber)="copyToClipboard($event)">
    </app-rsa-service-history>
</div>

